module.exports = __webpack_public_path__ + "img/lqBtn.1786555f.png";